import InternalRedirect from "./InternalRedirect";
export default InternalRedirect;
export { InternalRedirect };
